import { memo, MouseEventHandler } from 'react';

import { TableToolsBar } from '@/lib/v2/organisms';

import { useActionBar } from '@/src/modules/AutomationModuleNew/hooks/useActionBar';

type ActionBarJourneyMessagesProps = {
  totalRowSelected: number;
  showDownloadButton?: boolean;
  onClickDownload?: MouseEventHandler<HTMLButtonElement>;
};

const ActionBar = ({
  totalRowSelected,
  showDownloadButton = false,
  onClickDownload,
}: ActionBarJourneyMessagesProps) => {
  const { actions } = useActionBar({
    totalRowSelected,
    showDownloadButton,
    onClickDownload,
  });

  return (
    <TableToolsBar>
      {actions
        .filter((element) => !element.hide)
        .map((element) => {
          const { label, icon, tooltip, onClick: handleOnClick, id } = element;
          return (
            <TableToolsBar.Button
              key={id}
              icon={icon}
              id={id}
              label={label}
              tooltip={tooltip}
              onClick={handleOnClick}
            />
          );
        })}
    </TableToolsBar>
  );
};

export default memo(ActionBar);
